import request from '@/utils/request'

export function epmsa050(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa050/epmsa050`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}


export function epmsa051(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa050/epmsa051`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}